import React from 'react'
import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { faHammer, faHeadset } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { SupportPageRoute } from '@/routes/support/SupportPage.route'

export const PhoneSupportRoute: TileRoleRoute = {
  path: 'phonesupport',
  text: 'Supporto (Telefonica)',
  faIcon: faHeadset,
  element: (
    <ManagementGridFactory
      entity="tipologia_assistenza_telefonica"
      referencesCollection="assistenze"
      referencesTitle="Supporto (Telefonica)"
      displayField="ded_Dis"
      entityRoute={SupportPageRoute.path}
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Supporto (Telefonica)',
      icon: faHeadset,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
